import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { configureStore } from './config/stores'
import Routes from './components/routes/Routes'
import './App.scss'
import ReactGA from 'react-ga';

const TRACKING_ID = "G-MK9LLGXEQZ";
ReactGA.initialize(TRACKING_ID);

let store = configureStore()

class App extends Component {
  render () {
    return (
      <Provider store={store}>
        <Routes />
      </Provider>
    )
  }
}

export default App
